import $ from 'jquery';

$(function () {
    $('.no-click').on('click', function (evt) { evt.preventDefault(); });
});